<div class="login-container">
<div class="go-to-login">
    Already registered?
    <a href="/login">Go to Login</a>
  </div>
  <h2 class="page-title">Registration</h2>

  <!-- User Type Toggle -->
  <div class="usertype-container">
    <label class="radio-pill">
      <input type="radio" name="userType" [(ngModel)]="userType" value="vendor" />
      <span>Vendor</span>
    </label>
    <label class="radio-pill">
      <input type="radio" name="userType" [(ngModel)]="userType" value="employee" />
      <span>Employee</span>
    </label>
  </div>
  
  <!-- Dynamic Form -->
  <div class="form-wrapper">
    <app-vendor-registration *ngIf="userType === 'vendor'"></app-vendor-registration>
    <app-employee-registration *ngIf="userType === 'employee'"></app-employee-registration>
  </div>
</div>